import { useEffect } from "react";
import Lenis from "lenis";
import "lenis/dist/lenis.css";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import Marquee from "@/components/Marquee";
import AboutTemple from "@/components/AboutTemple";
import OurStory from "@/components/OurStory";
import BabaLifeStory from "@/components/BabaLifeStory";
import BabaTeachings from "@/components/BabaTeachings";
import FamousDevotees from "@/components/FamousDevotees";
import PhotoGallery from "@/components/PhotoGallery";
import FestivalCalendar from "@/components/FestivalCalendar";
import OshoMeditations from "@/components/OshoMeditations";
import NewTempleAppeal from "@/components/NewTempleAppeal";
import VisitAndSeva from "@/components/VisitAndSeva";
import StayAndExplore from "@/components/StayAndExplore";
import Footer from "@/components/Footer";
import ChantingPlayer from "@/components/ChantingPlayer";
import { useSEO } from "@/lib/useSEO";

export default function HomePage() {
  useSEO({
    title: "Neem Karoli Baba Temple Dallas–DFW | Hanuman Mandir in Denison, TX",
    description: "Neem Karoli Baba (Maharajji) temple near Dallas–Fort Worth — DFW's Hanuman mandir in Denison, TX. Saturday darshan, aarti & bhandara. Support the new temple building fund.",
    canonical: "https://neemkarolibabadallas.org/",
  });
  useEffect(() => {
    const lenis = new Lenis({ autoRaf: true, anchors: true, duration: 1.15 });
    return () => lenis.destroy();
  }, []);

  return (
    <div data-testid="home-page" className="relative">
      <div className="grain-overlay" aria-hidden="true" />
      <Navbar />
      <main>
        <HeroSection />
        <Marquee />
        <AboutTemple />
        <OurStory />
        <BabaLifeStory />
        <BabaTeachings />
        <FamousDevotees />
        <PhotoGallery />
        <FestivalCalendar />
        <OshoMeditations />
        <NewTempleAppeal />
        <VisitAndSeva />
        <StayAndExplore />
      </main>
      <Footer />
      <ChantingPlayer />
    </div>
  );
}
